import { useEffect } from "react";
import { useUserStore } from "../../store/userStore.js";
import { useLocation } from "react-router-dom";
import { message, Switch, Popconfirm } from "antd";


import { PrimaryButton } from "../button";

export default function AccountStatusComp() {
  const { user, getUser, updateUser } = useUserStore();
  const location = useLocation();

  const username = location.pathname.split("/")[2];

  useEffect(() => {
    getprofileData();
  }, [username]);

  const getprofileData = () => {
    const payload = { username };
    getUser(payload);
  };

  const handlePhotoBlur = (e) => {
    const payload = {
      username: user?.username,
      data: {
        isPhotoBlured: e,
      },
    };
    updateUser(payload, () => {
      getprofileData();
    });
  };
  const handleContactHidden = (e) => {
    const payload = {
      username: user?.username,
      data: {
        isContactHidden: e,
      },
    };
    updateUser(payload, () => {
      getprofileData();
    });
  };

  const handleUpdateStatus = async (status) => {
    console.log(status, user.status);
    if (status === "deactivate" && user?.status === "deactivate") {
      message.error("User is already deactivated");
      return;
    }
    if (status === "delete" && user?.status === "delete") {
      message.error("User is already deleted");
      return;
    }
    const payload = {
      username: user?.username,
      data: { status },
    };
    updateUser(payload, () => {
      getprofileData();
    });
  };

  return (
    <div className="w-full flex flex-col gap-6">
      <h2>Account Status</h2>
      <div className="w-full flex-col justify-start items-start gap-[42px] flex pr-8">
        <div className="self-stretch justify-between items-center inline-flex">
          <div className="flex-col justify-start items-start gap-2 inline-flex">
            <div className="text-[#f31260] text-sm font-semibold font-['Poppins'] leading-tight">
              Deactivate Account
            </div>
            <div className="w-[502px] text-[#222222]/60 text-xs font-normal font-['Poppins'] leading-[18px]">
              We’d hate to him go, but he is welcome to deactivate his account
              anytime. Just remember, once he delete it, it’s gone forever.
            </div>
          </div>
          <Popconfirm
            title={`${
              user?.status === "deactivate" ? "Reactivate" : "Deactivate"
            }  user?`}
            description={`Are you sure you want to ${
              user?.status === "deactivate" ? "reactivate" : "deactivate"
            } this user?`}
            onConfirm={() =>
              handleUpdateStatus(
                user?.status === "deactivate" ? "active" : "deactivate"
              )
            }
            okText="Yes"
            cancelText="No"
          >
            <PrimaryButton
              style={{
                width: "158px",
                height: "40px",
                fontSize: "12px",
                background: "#f8e6ef",

                color: "#ba0060",
              }}
              text={user?.status === "deactivate" ? "Reactivate" : "Deactivate"}
            />
          </Popconfirm>
        </div>
        <div className="self-stretch justify-between items-center inline-flex">
          <div className="flex-col justify-start items-start gap-2 inline-flex">
            <div className="text-[#f31260] text-sm font-semibold font-['Poppins'] leading-tight">
              Delete Account
            </div>
            <div className="w-[502px] text-[#222222]/60 text-xs font-normal font-['Poppins'] leading-[18px]">
              Just remember, once you delete it, it’s gone forever.
            </div>
          </div>
          <Popconfirm
            title={`${
              user?.status === "delete" ? "Activate" : "Delete"
            }  user?`}
            description={`Are you sure you want to ${
              user?.status === "delete" ? "activate" : "delete"
            } this user?`}
            onConfirm={() =>
              handleUpdateStatus(
                user?.status === "delete" ? "active" : "delete"
              )
            }
            okText="Yes"
            cancelText="No"
          >
            <PrimaryButton
              style={{
                width: "158px",
                height: "40px",
                fontSize: "12px",
                background: "#f8e6ef",

                color: "#ba0060",
              }}
              text={user?.status === "delete" ? "Activate" : "Delete"}
            />
          </Popconfirm>
        </div>
        <div className="w-full self-stretch h-[238px] flex-col justify-start items-start gap-5 flex">
          <div className="text-basePrimary text-base font-semibold font-['Poppins'] leading-normal">
            Privacy
          </div>
          <div className="w-full flex-col justify-start items-start gap-5 flex">
            <div className="w-full h-[77px] flex-col justify-start items-start gap-2 flex">
              <div className="text-[#222222] text-sm font-semibold font-['Poppins'] leading-tight">
                Photo Access
              </div>
              <div className="w-full h-[49px] flex-col justify-start items-start gap-[7px] flex">
                <div className="w-full justify-between items-center inline-flex">
                  <div className="text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
                    Keep his photo blurred
                  </div>
                  <div className="justify-start items-center gap-2 flex">
                    <Switch
                      onChange={handlePhotoBlur}
                      checked={user?.isPhotoBlured}
                    />
                  </div>
                </div>
                <div className="justify-start items-end gap-[551px] inline-flex">
                  <div className="text-[#222222]/60 text-xs font-normal font-['Poppins'] leading-[18px]">
                    Blur or reveal your photo. Males can toggle; females are
                    blurred by default.
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full h-[0px] border border-primary50"></div>
            <div className="w-full h-[77px] flex-col justify-start items-start gap-2 flex">
              <div className="text-[#222222] text-sm font-semibold font-['Poppins'] leading-tight">
                Contact Access
              </div>
              <div className="w-full h-[49px] flex-col justify-start items-start gap-[7px] flex">
                <div className="w-full justify-between items-center inline-flex">
                  <div className="w-full text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
                    Keep his number hidden
                  </div>
                  <div className="justify-start items-center gap-2 flex">
                    <Switch
                      onChange={handleContactHidden}
                      checked={user?.isContactHidden}
                    />
                  </div>
                </div>
                <div className="w-full justify-start items-end gap-[551px] inline-flex">
                  <div className="text-[#222222]/60 text-xs font-normal font-['Poppins'] leading-[18px]">
                    Only females can keep their number hidden.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}








